var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgService3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 175,
    viewBox: "0 0 176 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 173,
    height: 172,
    rx: 18.5,
    stroke: "url(#paint0_linear_1537_1317)",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9102 26.7812H120.382C120.528 26.7812 120.725 26.86 120.912 27.1104C121.099 27.3604 121.237 27.7403 121.237 28.1885V118.708H123.656C123.802 118.708 123.998 118.787 124.186 119.037C124.372 119.287 124.511 119.667 124.511 120.115V128.87C124.511 129.318 124.373 129.698 124.186 129.948C123.998 130.199 123.801 130.278 123.655 130.278H51.6367C51.4906 130.278 51.2939 130.199 51.1064 129.948C50.9195 129.698 50.7812 129.318 50.7812 128.87V120.115C50.7813 119.667 50.9196 119.288 51.1064 119.038C51.2939 118.787 51.4906 118.708 51.6367 118.708H54.0547V28.1885C54.0548 27.7403 54.1929 27.3604 54.3799 27.1104C54.5672 26.8599 54.7641 26.7814 54.9102 26.7812ZM52.4922 121.523V127.463H122.8V121.523H52.4922ZM121.237 123.086V125.9H54.0547V123.086H121.237ZM55.7656 29.5957V118.708H86.791V79.9375H60.6016V77.1221H86.791V35.5361H88.502V77.1221H114.69V79.9375H88.502V118.708H119.526V29.5957H55.7656ZM117.964 31.1582V117.146H116.253V36.9434C116.253 36.1879 116.023 35.473 115.616 34.9297C115.21 34.3872 114.589 33.9737 113.835 33.9736H61.458C60.7039 33.9736 60.0816 34.3871 59.6758 34.9297C59.2695 35.473 59.0391 36.1879 59.0391 36.9434V117.146H57.3281V31.1582H117.964Z",
    fill: "url(#paint1_linear_1537_1317)",
    stroke: "url(#paint2_linear_1537_1317)",
    strokeWidth: 1.5625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.126 145.881V124.381L133.625 110.381L129.625 92.8811L137.625 89.3811L127.625 91.8811C125.225 92.2811 123.958 91.7145 123.625 91.3811L113.126 80.8811C112.96 80.5477 112.826 79.681 113.626 78.881C114.426 78.081 115.96 78.5476 116.626 78.881L125.626 86.881L138.126 83.8807C141.326 83.4807 142.793 86.7141 143.126 88.3807L147.126 108.381L146.126 128.381L150.626 143.881C150.793 144.881 150.626 147.081 148.626 147.881C146.626 148.681 144.793 147.214 144.126 146.381L138.626 130.381C138.226 129.581 138.126 127.714 138.126 126.881L139.126 114.881L134.126 126.881V146.381C133.793 146.881 132.626 147.881 130.626 147.881C128.626 147.881 127.46 146.547 127.126 145.881Z",
    fill: "url(#paint3_linear_1537_1317)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.626 84.3811L119.625 77.8811L121.625 75.3811L132.125 84.3811H125.626Z",
    fill: "url(#paint4_linear_1537_1317)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.125 79.8811C127.725 77.8811 127.625 72.7145 128.125 70.3811L141.625 76.3811C140.292 78.3811 136.525 81.8811 132.125 79.8811Z",
    fill: "url(#paint5_linear_1537_1317)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.125 74.3811L124.625 66.8811L128.625 66.3811C129.792 64.5478 133.425 61.4811 138.625 63.8811C143.825 66.2811 143.792 71.8811 143.125 74.3811Z",
    fill: "url(#paint6_linear_1537_1317)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.126 145.881V124.381L133.625 110.381L129.625 92.8811L137.625 89.3811L127.625 91.8811C125.225 92.2811 123.958 91.7145 123.625 91.3811L113.126 80.8811C112.96 80.5477 112.826 79.681 113.626 78.881C114.426 78.081 115.96 78.5476 116.626 78.881L125.626 86.881L138.126 83.8807C141.326 83.4807 142.793 86.7141 143.126 88.3807L147.126 108.381L146.126 128.381L150.626 143.881C150.793 144.881 150.626 147.081 148.626 147.881C146.626 148.681 144.793 147.214 144.126 146.381L138.626 130.381C138.226 129.581 138.126 127.714 138.126 126.881L139.126 114.881L134.126 126.881V146.381C133.793 146.881 132.626 147.881 130.626 147.881C128.626 147.881 127.46 146.547 127.126 145.881Z",
    stroke: "url(#paint7_linear_1537_1317)",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.626 84.3811L119.625 77.8811L121.625 75.3811L132.125 84.3811H125.626Z",
    stroke: "url(#paint8_linear_1537_1317)",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.125 79.8811C127.725 77.8811 127.625 72.7145 128.125 70.3811L141.625 76.3811C140.292 78.3811 136.525 81.8811 132.125 79.8811Z",
    stroke: "url(#paint9_linear_1537_1317)",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M143.125 74.3811L124.625 66.8811L128.625 66.3811C129.792 64.5478 133.425 61.4811 138.625 63.8811C143.825 66.2811 143.792 71.8811 143.125 74.3811Z",
    stroke: "url(#paint10_linear_1537_1317)",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5494 145.881V124.381L42.0508 110.381L46.0508 92.8811L38.0508 89.3811L48.0508 91.8811C50.4508 92.2811 51.7174 91.7145 52.0508 91.3811L62.5494 80.8811C62.716 80.5477 62.8494 79.681 62.0494 78.881C61.2494 78.081 59.716 78.5476 59.0494 78.881L50.0494 86.881L37.5494 83.8807C34.3493 83.4807 32.8827 86.7141 32.5494 88.3807L28.5494 108.381L29.5494 128.381L25.0494 143.881C24.8827 144.881 25.0494 147.081 27.0494 147.881C29.0494 148.681 30.8827 147.214 31.5494 146.381L37.0494 130.381C37.4494 129.581 37.5494 127.714 37.5494 126.881L36.5494 114.881L41.5494 126.881V146.381C41.8827 146.881 43.0494 147.881 45.0494 147.881C47.0494 147.881 48.216 146.547 48.5494 145.881Z",
    fill: "url(#paint11_linear_1537_1317)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0494 84.3811L56.0508 77.8811L54.0508 75.3811L43.5508 84.3811H50.0494Z",
    fill: "url(#paint12_linear_1537_1317)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5508 79.8811C47.9508 77.8811 48.0508 72.7145 47.5508 70.3811L34.0508 76.3811C35.3841 78.3811 39.1508 81.8811 43.5508 79.8811Z",
    fill: "url(#paint13_linear_1537_1317)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5508 74.3811L51.0508 66.8811L47.0508 66.3811C45.8841 64.5478 42.2508 61.4811 37.0508 63.8811C31.8508 66.2811 31.8841 71.8811 32.5508 74.3811Z",
    fill: "url(#paint14_linear_1537_1317)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5494 145.881V124.381L42.0508 110.381L46.0508 92.8811L38.0508 89.3811L48.0508 91.8811C50.4508 92.2811 51.7174 91.7145 52.0508 91.3811L62.5494 80.8811C62.716 80.5477 62.8494 79.681 62.0494 78.881C61.2494 78.081 59.716 78.5476 59.0494 78.881L50.0494 86.881L37.5494 83.8807C34.3493 83.4807 32.8827 86.7141 32.5494 88.3807L28.5494 108.381L29.5494 128.381L25.0494 143.881C24.8827 144.881 25.0494 147.081 27.0494 147.881C29.0494 148.681 30.8827 147.214 31.5494 146.381L37.0494 130.381C37.4494 129.581 37.5494 127.714 37.5494 126.881L36.5494 114.881L41.5494 126.881V146.381C41.8827 146.881 43.0494 147.881 45.0494 147.881C47.0494 147.881 48.216 146.547 48.5494 145.881Z",
    stroke: "url(#paint15_linear_1537_1317)",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0494 84.3811L56.0508 77.8811L54.0508 75.3811L43.5508 84.3811H50.0494Z",
    stroke: "url(#paint16_linear_1537_1317)",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5508 79.8811C47.9508 77.8811 48.0508 72.7145 47.5508 70.3811L34.0508 76.3811C35.3841 78.3811 39.1508 81.8811 43.5508 79.8811Z",
    stroke: "url(#paint17_linear_1537_1317)",
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5508 74.3811L51.0508 66.8811L47.0508 66.3811C45.8841 64.5478 42.2508 61.4811 37.0508 63.8811C31.8508 66.2811 31.8841 71.8811 32.5508 74.3811Z",
    stroke: "url(#paint18_linear_1537_1317)",
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5378 134.281C82.5265 134.213 82.517 134.148 82.5093 134.084C82.5059 134.056 82.5028 134.028 82.5 134H63V144H113.5V134H94.5C94.4911 134.089 94.4786 134.183 94.4622 134.281M82.5378 134.281C82.8283 136.013 84.3351 139 88.5 139C92.6649 139 94.1717 136.013 94.4622 134.281M82.5378 134.281H94.4622M71.5 136C70.1667 136 68.5 137.146 68.5 139C68.5 140.854 70.1667 141.5 71.5 141.5C72.8333 141.5 74.5 141 74.5 139C74.5 136.847 72.8333 136 71.5 136ZM106.5 136.5C105.167 136.5 103.5 137.646 103.5 139.5C103.5 141.354 105.167 142 106.5 142C107.833 142 109.5 141.5 109.5 139.5C109.5 137.347 107.833 136.5 106.5 136.5ZM85 135.5L85.5 136.5H91.5L92 135.5H85Z",
    stroke: "url(#paint19_linear_1537_1317)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1537_1317",
    x1: 88,
    y1: 0,
    x2: 88,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1537_1317",
    x1: 87.6462,
    y1: 26,
    x2: 87.6462,
    y2: 131.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1537_1317",
    x1: 87.6462,
    y1: 26,
    x2: 87.6462,
    y2: 131.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1537_1317",
    x1: 131.838,
    y1: 63,
    x2: 131.838,
    y2: 148.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1537_1317",
    x1: 131.838,
    y1: 63,
    x2: 131.838,
    y2: 148.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1537_1317",
    x1: 131.838,
    y1: 63,
    x2: 131.838,
    y2: 148.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1537_1317",
    x1: 131.838,
    y1: 63,
    x2: 131.838,
    y2: 148.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1537_1317",
    x1: 131.838,
    y1: 63,
    x2: 131.838,
    y2: 148.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1537_1317",
    x1: 131.838,
    y1: 63,
    x2: 131.838,
    y2: 148.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1537_1317",
    x1: 131.838,
    y1: 63,
    x2: 131.838,
    y2: 148.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1537_1317",
    x1: 131.838,
    y1: 63,
    x2: 131.838,
    y2: 148.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1537_1317",
    x1: 43.8381,
    y1: 63,
    x2: 43.8381,
    y2: 148.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1537_1317",
    x1: 43.8381,
    y1: 63,
    x2: 43.8381,
    y2: 148.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1537_1317",
    x1: 43.8381,
    y1: 63,
    x2: 43.8381,
    y2: 148.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1537_1317",
    x1: 43.8381,
    y1: 63,
    x2: 43.8381,
    y2: 148.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1537_1317",
    x1: 43.8381,
    y1: 63,
    x2: 43.8381,
    y2: 148.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1537_1317",
    x1: 43.8381,
    y1: 63,
    x2: 43.8381,
    y2: 148.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1537_1317",
    x1: 43.8381,
    y1: 63,
    x2: 43.8381,
    y2: 148.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1537_1317",
    x1: 43.8381,
    y1: 63,
    x2: 43.8381,
    y2: 148.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1537_1317",
    x1: 88.25,
    y1: 134,
    x2: 88.25,
    y2: 144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgService3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/service3.7745afc64ed2d1bb1080edf011e0cf8a.svg";